import Icon from "components/Elements/Icon/Icon";
import PRODUCT_LIST from "../../helpers/productList";
import useIsIsraelUser from "../MegaMenu/hooks/useIsIsraelUser";

import {
  ButtonA,
  ButtonAccessability,
} from "components/Elements/Button/Button";
import { LinkToNewTab } from "components/Elements/Link/Link";
import { memo } from "react";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./drawerForBusinessesSection.module.scss";

interface DrawerForBusinessesSectionI
  extends React.HTMLAttributes<HTMLDivElement> {
  setShowSection: React.Dispatch<
    React.SetStateAction<"features" | "for-businesses" | "">
  >;
}

const DrawerForBusinessesSection = (props: DrawerForBusinessesSectionI) => {
  const { setShowSection, ...restProps } = props;

  const { getTextByKey, getDirection } = useContent();

  const isIsraelUser = useIsIsraelUser();

  return (
    <div className={styles.wrapper} {...restProps}>
      <ButtonAccessability onClick={() => setShowSection("")}>
        <h3 className={styles.title}>
          <Icon
            name={getDirection() === "rtl" ? "arrow-right" : "arrow-left"}
            gray
          />
          {getTextByKey("for-businesses")}
        </h3>
      </ButtonAccessability>
      <div className={styles.businessPromo}>
        <div className={styles.promoTitle}>
          <div className={styles.icon}>
            <Icon name="briefcase" />
          </div>
          <h3>{getTextByKey("for-businesses-title")}</h3>
        </div>
        <p>{getTextByKey("for-businesses-description")}</p>
        {/* @ts-ignore */}
        <ButtonA page="for-businesses">{getTextByKey("learn-more")}</ButtonA>
      </div>
      <ul>
        {PRODUCT_LIST.filter((product) =>
          // Show JUMBOpay only for users from Israel
          product.name === PRODUCT_LIST[2].name ? isIsraelUser : true
        ).map(({ name, link }) => (
          <li key={name}>
            {/*@ts-ignore*/}
            <LinkToNewTab page={link}>
              <Icon name={`mega-menu/${name}`} xl />
              <span>JUMBO{name}</span>
            </LinkToNewTab>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default memo(DrawerForBusinessesSection);
